import { observer } from 'mobx-react-lite';
import { Icon } from 'semantic-ui-react';
import { useStore } from './../../app/stores/store';
import reactStringReplace from 'react-string-replace';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { userLanguage } from './../../app/common/userLanguageSchema/userLanguage';

interface Props {
  header: any;
  tableName: string;
  pageNum: number;
  chosenHeader?: string[] | [];
  name?: string;
  sortHandler: any;
}
function SortData({ header, tableName, pageNum, chosenHeader, name,sortHandler }: Props) {
  const { id } = useParams<{ id: string }>();
  const {
    activityStore,
    dashboardStore,
    receivingdeliveryStore,
    emailStore,
    userStore,
    reportStore,
    WorkLevelStore,
    commonStore,
    CRMStore
  } = useStore();
  const { handleIntentorySort } = CRMStore;
  const sortFunction = (headerData: any) => {
    const OrderDirection =
      dashboardStore.dashboard.orderData === 'Ascending'
        ? 'Descending'
      : 'Ascending'; //order direction
      const OrderDirectionHFC = dashboardStore.dashboard.orderData === 'Ascending' ? true : false;

    dashboardStore.setOrderIcon(
      headerData,
      OrderDirection === 'Ascending'
        ? 'triangle up'
        : OrderDirection === 'Descending'
          ? 'triangle down'
          : '',
    ); //order Icon and name
    dashboardStore.setOrderData(OrderDirection); //order direction
    dashboardStore.dashboard.searchfilterparams = {};
    if (
      userStore.user?.customerName === 'LVPCMS' &&
      (tableName === 'AssetTable' || tableName === 'QuickScan')
    ) {
      dashboardStore.updateCountOrderMenu(userStore.user?.id);
      activityStore.sortListItemsNotFF(headerData, OrderDirection, pageNum); //api call
    }
    if (
      userStore.user?.customerName === 'LVPCMS' &&
      tableName === 'FilmFestivalReport'
    ) {
      reportStore.sortListItemsFF(headerData, OrderDirection, pageNum); //api call
    }
    if (
      userStore.user?.customerName !== 'LVPCMS' &&
      (tableName === 'AssetTable' || tableName === 'InventoryReportsTable')
    ) {
      const pageSize = userStore.user?.customerName === 'Restoration' ? 20 : 5;
      commonStore.hfcCustomerChanges && tableName !== "AssetTable"
        ? activityStore.HFCsortListItems(headerData, OrderDirectionHFC, 1, pageSize)
        : !commonStore.hfcCustomerChanges && activityStore.sortListItems(headerData, OrderDirection, 1, pageSize);
        ((commonStore.hfcCustomerChanges && tableName !== "AssetTable") || !commonStore.hfcCustomerChanges) && dashboardStore.updateCountOrderMenu(userStore.user?.id);
    }
    if (tableName === 'QuickScan') {
      activityStore.sortListItems(headerData, OrderDirection, pageNum, 20); //api call
      dashboardStore.updateCountOrderMenu(userStore.user?.id);
    }
    if (tableName === 'AllocateUser') {
      dashboardStore.updateCountOrderMenu(userStore.user?.id);
      activityStore.sortListItems(headerData, OrderDirection, pageNum, 10); //api call
    }
    if (tableName === 'TagTable') {
      dashboardStore.tagCount();
      activityStore.sortListTag(headerData, OrderDirection, pageNum); //api call
    }
    if (tableName === 'prodPlanTable') {
      let destructData = dashboardStore.dashboard;
      activityStore.sortProductionPlanning(
        destructData.setProductionType,
        destructData.setProductionTask,
        headerData,
        OrderDirection,
        pageNum,
      ); //api call
    }
    if (tableName === 'CreateOrderTable') {
      dashboardStore.createOrderCount();
      activityStore.sortListCR(headerData, OrderDirection, pageNum); //api call
    }

    if (tableName === 'ReceivingTable') {
      dashboardStore.updateCountOrderMenu(userStore.user?.id);
      receivingdeliveryStore.sortReceivingList(
        headerData,
        OrderDirection,
        pageNum,
      ); //api call
    }
    if (tableName === 'EmailTable') {
      emailStore.emailMessageSort(OrderDirection, headerData, pageNum); //api call
    }
    if (tableName === 'AlertsTable') {
      emailStore.emailAlertSort(OrderDirection, headerData, pageNum); //api call
    }
    if (tableName === 'ReportsTable' || tableName === 'SmartTracker') {
      let chosenHeaderData = [...chosenHeader!];
      chosenHeaderData.push('id');
      if (!headerData.includes('metadata/')) {
        reportStore.sortMetaDataReport(
          headerData,
          OrderDirection,
          pageNum,
          chosenHeaderData!,
        ); //api call
      } //api call
    }
    if (tableName === 'viewHistoryTable') {
      let params = {
        itemid: id || '',
        sortvalue: header || '',
        sortby: OrderDirection,
        PageNumber: pageNum,
        PageSize: 5,
      };
      activityStore.viewHistorySort(params);
    }
    if (tableName === 'viewTemplateTable') {
      let params = {
        ItemId: id || '',
        SortValue: header || '',
        SortBy: OrderDirection,
        PageNumber: pageNum,
        PageSize: 5,
      };
      activityStore.viewTemplateSort(params);
    }
    if (
      tableName === 'NewAssetAdded' ||
      tableName === 'DigitalizationPriority' ||
      tableName === 'AssetsCleaned' ||
      tableName === 'CurrentMonthAssetCANMovement' ||
      tableName === 'PendingReturnsFromBorrowers' ||
      tableName === 'AssetsScheduledForCleaning'
    ) {
      activityStore.inventoryReportsFetchSortTableDetails(
        OrderDirection,
        tableName,
        header || '',
        pageNum,
        (activityStore.inventoryReports as any)[`${_.camelCase(tableName)}`]
          .count || 0,
      );
    }
    if (
      tableName === 'Received' ||
      tableName === 'WaitingforApproval' ||
      tableName === 'Approved' ||
      tableName === 'InProgress' ||
      tableName === 'Ready' ||
      tableName === 'Delivered' ||
      tableName === 'Returned'
    ) {
      activityStore.OrdersReportsFetchSortTableDetails(
        OrderDirection,
        tableName,
        header || '',
        pageNum,
        (activityStore.OrdersReports as any)[`${_.camelCase(tableName)}`]
          .count || 0,
      );
    }
    if (
      tableName === 'Verify' ||
      tableName === 'Approve' ||
      tableName === 'PickerAssign' ||
      tableName === 'MoveToVault'
    ) {
      activityStore.inwardFetchSortTableDetails(
        OrderDirection,
        tableName,
        header || '',
        pageNum,
        (activityStore.inward as any)[`${_.camelCase(tableName)}`].count || 0,
      );
    }
    if (
      tableName === 'Unvault' ||
      tableName === 'VerifyOutward' ||
      tableName === 'ApproveOutward' ||
      tableName === 'AssignPickerOutward' ||
      tableName === 'Move' ||
      tableName === 'Package' ||
      tableName === 'Billing'
    ) {
      activityStore.outwardFetchSortTableDetails(
        OrderDirection,
        tableName,
        header || '',
        pageNum,
        (activityStore.outward as any)[`${_.camelCase(tableName)}`].count || 0,
      );
    }
    if (tableName === 'TagOrder') {
      activityStore.tagOrderFetchSortTableDetails(
        OrderDirection,
        tableName,
        header || '',
        pageNum,
        (activityStore.outward as any)[`${_.camelCase(tableName)}`].count || 0,
      );
    }
    // view item group
    if (tableName === 'WorkLevelTable') {
      WorkLevelStore.viewItemGroupSortDetails(OrderDirection, pageNum);
    }
      if(tableName === 'ReadMail'){
    sortHandler(headerData,OrderDirection==='Ascending',pageNum,'ReadMail')
      }
      if(tableName === 'UnreadMail'){
        sortHandler(headerData,OrderDirection==='Ascending',pageNum,'UnreadMail')
      }
      if(tableName === 'IT Asset List'){
        CRMStore.itAssetTableDetails.pageNumber = 1;
        handleIntentorySort(headerData,OrderDirection,1);
      }
    };

    const nameFunction = (headerData: any): any => {
      if (dashboardStore.dashboard.orderName === headerData) {
        return dashboardStore.dashboard.orderIcon;
      } else {
        return '';
      }
    };

    const translateHeader = (header: any, lang: any, tableName: string)=>{
      if(tableName === "AssetTable"){
      const assetTable: any = userLanguage[0]?.AssetTable?.AT01;
      const translationMap: any = assetTable[lang];
      return translationMap[header]
      }else if(tableName === "ReceivingTable"){
      const receivingTable: any = userLanguage[0]?.ReceivingTable?.R001;
      const ReceivingTranslationMap: any = receivingTable[lang];
      return ReceivingTranslationMap[header]
      }else if(tableName === "TagTable"){
        const TagTable: any = userLanguage[0]?.TagTable?.TT01;
        const TagTranslationMap: any = TagTable[lang];
        return TagTranslationMap[header]
        }else if(tableName === "CreateOrderTable"){
          const OrderTable: any = userLanguage[0]?.CreateOrderTable?.COT01;
          const OrderTranslationMap: any = OrderTable[lang];
          return OrderTranslationMap[header]
        }else if(tableName === "ReadMail"){
          const ReadMailTable: any = userLanguage[0]?.MessagesTable?.MT01;
          const ReadMailTranslationMap: any = ReadMailTable[lang];
          return ReadMailTranslationMap[header]
        } else if(tableName === "UnreadMail"){
          const UnreadMailTable: any = userLanguage[0]?.MessagesTable?.MT01;
          const UnreadMailTranslationMap: any = UnreadMailTable[lang];
          return UnreadMailTranslationMap[header]
        }else if(tableName === "AlertsTable"){
          const AlertsTable: any = userLanguage[0]?.AlertsTable?.ALT01;
          const AlertsTranslationMap: any = AlertsTable[lang];
          return AlertsTranslationMap[header]
        }else{
        return header
      }
    }
    
    
    return (
    <div
      onClick={() => name !== 'SmartTracker' && sortFunction(header)}
      key={header}
    >
      {name !== 'SmartTracker' && userStore.user?.customerName !== 'BroekmanLogistics'
        ?
        reactStringReplace(
            (
              header.charAt(0).toUpperCase() +
              header.slice(1).split('_').join(' ')
            )
              .split(' ')
              .filter((i: any) => i.toLowerCase().replaceAll('metadata/ ', ''))
              .map((i: any) => i.charAt(0).toUpperCase() + i.slice(1) + ' '),
            /([A-Z])/,
            (m: any) => {
              return ' ' + m;
            },
          ).join('')

        // ? nameFunction(header)8
        : userStore.user?.customerName === 'BroekmanLogistics' ? translateHeader(header.replaceAll('metadata/ ', '').replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(
          /\w\S*/g,
          (txt: any) =>
            txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        ), commonStore.language.key, tableName):header
            .replaceAll('metadata/ ', '')
            .replace(/_/g, ' ')
            .replace(
              /\w\S*/g,
              (txt: any) =>
                txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
            )}
      <Icon name={nameFunction(header)} />
    </div>
  );
}

export default observer(SortData);
